import { render, staticRenderFns } from "./start-experiences.vue?vue&type=template&id=8da54fee&scoped=true&"
import script from "./start-experiences.vue?vue&type=script&lang=js&"
export * from "./start-experiences.vue?vue&type=script&lang=js&"
import style0 from "./start-experiences.vue?vue&type=style&index=0&id=8da54fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da54fee",
  null
  
)

export default component.exports